let window;
if (typeof window === 'undefined') {
  window = {
    executeOnceFlag: false,
  };
} else {
  window = window;
}

/**
 * Function for different debugging levels
 *
 * @param {type} - "INFO", "LOOK" , "TABLE", "ERROR"
 * @param {msg} - Message to be printed for the variable representation
 * @param {var_} - Value of the variable
 * @return {}  Debugging Mode for Any Type of variables
 */
const executeOnce = () => {
  window.executeOnceFlag = false;
  //FIXME: Only for DEVELOPMENT Purpose
  if (!window.executeOnceFlag) {
    if ("process.env.REACT_APP_ENV" !== "production" || true) {
      console.clear();
      console.log(
        "%c ES Debug Mode ",
        "background: #1fdfdd; color: white; font-size: 20px; font-family: monospace"
      );
    } else {
      console.clear();
      console.log(
        "%c ES Production Mode ",
        "background: #5cb85c; color: white; font-size: 20px; font-family: monospace"
      );
    }
    window.executeOnceFlag = true;
  }
};
executeOnce();
const debug = (type = "INFO", msg = "", var_ = "", ...args) => {
  //FIXME: Only for DEVELOPMENT Purpose
  if ("process.env.REACT_APP_ENV" !== "production" || true) {
    if (type.toLowerCase() == "info") {
      console.log(
        `%c INFO: `,
        "background: #5bc0de; color: white",
        msg,
        ...args
      );
    } else if (type.toLowerCase() == "look" || type.toLowerCase() == "watch") {
      console.log(
        `%c LOOK: `,
        "background: #5cb85c; color: white",
        `${msg} → `,
        var_,
        ...args
      );
    } else if (type.toLowerCase() == "error") {
      console.log(
        `%c ERROR: `,
        "background: #d9534f; color: white",
        msg,
        var_,
        ...args
      );
    } else if (type.toLowerCase() == "table") {
      console.log(
        `%c TABLE: `,
        "background: #f0ad4e; color: white",
        msg,
        ...args
      );
      console.table(var_);
    } else if (type.toLowerCase() == "qa-only") {
      console.log(
        `%c INTERNAL: `,
        "background: #0000cc; color: white",
        msg,
        ...args
      );
      console.table(var_);
    } else if (type.toLowerCase() == "request") {
      console.log(
        `%c REQUEST: `,
        "background: #00008B; color: white",
        msg,
        var_,
        ...args
      );
    } else if (type.toLowerCase() == "response") {
      console.log(
        `%c RESPONSE: `,
        "background: 	#006400; color: white",
        msg,
        var_,
        ...args
      );
    }
  }
};

export default debug;
